import React from 'react';
import Container from '../components/Container.jsx';
import SectionDivider from '../components/SectionDivider.jsx';
import Card from '../components/Card.jsx';
import FeatureHighlight from '../components/FeatureHighlight.jsx';

const services = [
  { icon: '🍽️', title: 'Traiteur entreprises', description: 'Buffets, plateaux-repas, cocktails pour vos événements professionnels.' },
  { icon: '🚚', title: 'Livraison', description: 'Livraison rapide et soignée dans toute la ville.' },
  { icon: '🎉', title: 'Événementiel', description: 'Organisation de petits-déjeuners, pauses gourmandes, inaugurations.' },
  { icon: '📝', title: 'Devis sur-mesure', description: 'Demandez un devis personnalisé pour votre projet.' },
];

const cities = ['Paris', 'Lyon', 'Marseille', 'Bordeaux', 'Lille'];
const events = ['Séminaires', 'Réunions', 'Formations', 'Lancements', 'Célébrations'];

export function ServicesPage() {
  return (
    <>
      <Container className="py-12 max-w-4xl">
        <h1 className="text-3xl font-heading font-bold text-primary mb-6 text-center">Services aux entreprises</h1>
        <p className="text-lg text-text-secondary text-center mb-8">
          Antic accompagne les entreprises pour tous leurs besoins gourmands : traiteur, livraison, événementiel et plus encore.
        </p>
      </Container>
      <SectionDivider motif />
      <Container className="py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          {services.map((s) => (
            <FeatureHighlight key={s.title} {...s} />
          ))}
        </div>
        <div className="flex flex-wrap justify-center gap-8 mb-8">
          <div>
            <h3 className="font-heading font-bold text-primary mb-2 text-center">Villes desservies</h3>
            <ul className="text-text-secondary text-center">
              {cities.map((city) => (
                <li key={city}>{city}</li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="font-heading font-bold text-primary mb-2 text-center">Types d’événements</h3>
            <ul className="text-text-secondary text-center">
              {events.map((evt) => (
                <li key={evt}>{evt}</li>
              ))}
            </ul>
          </div>
        </div>
        <div className="text-center mt-12">
          <a href="#contact"><button className="btn-primary px-8 py-4 rounded-lg text-lg">Demander un devis</button></a>
        </div>
      </Container>
    </>
  );
}

export default ServicesPage;
